export const isExternalUrl = url => typeof url === 'object' ? false : (
  /^[a-z]+:/.test(url) || // e.g. http:// https:// mailto: tel:
  url.substr(0, 2) === '//'
)

export const isPathAbsolute = url =>
  typeof url === 'object'
    ? true
    : /^(?:\/|[a-z]+:)/.test(url)
